import cls from 'classnames';

export const outlineClasses = {
  blue: cls(`focus:border-btnInputFocus focus:ring-btnInputFocus`),
  red: cls(`focus:ring-btnInputError focus:border-btnInputError`),
  green: cls(`focus:ring-btnInputSuccess focus:border-btnInputSuccess`),
};

export const createValidationState = () => ({
  ...{
    isValid: true,
    message: '',
    inputClass: outlineClasses.blue,
    outputClass: 'invisible',
  },
});
